document.addEventListener("DOMContentLoaded", function () {
  const productOffer = document.querySelector(".product-offer");

  const isTartCherry =
    productOffer?.dataset.templateSuffix === "tart-cherry";

  const sliderThumbnail = new Swiper(".product-offer__nav-slider", {
    slidesPerView: 6,
    spaceBetween: 7,
    freeMode: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    breakpoints: {
      581: {
        slidesPerView: 5.5,
        spaceBetween: 16,
      }
    }
  });

  const sliderProdMain = new Swiper(".product-offer__main-slider", {
    spaceBetween: isTartCherry ? 8 : 12,
    slidesPerView: isTartCherry ? 1.05 : 1.15,
    loop: true,

    thumbs: {
      swiper: sliderThumbnail
    },

    navigation: {
      nextEl: ".swiper-button-next-button",
      prevEl: ".swiper-button-prev-button",
    },

    breakpoints: {
      581: {
        loop: false,
        slidesPerView: 1,
      }
    }
  });
});

// product offer
document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".product-offer__variant-item");
  const btnPrice = document.querySelector(".btn-price");
  const btnCompare = document.querySelector(".btn-compare");
  const subscriptionCheckbox = document.getElementById("offer-subscription");

  let isSub = subscriptionCheckbox?.checked || false;

  function updateButton(item) {
    btnPrice.textContent = isSub ? item.dataset.subscriptionPrice : item.dataset.price;
    btnCompare.textContent = item.dataset.comparePrice;
  }

  function updateAllItemsPrice() {
    items.forEach((item) => {
      const priceElem = item.querySelector(".price-reg");
      priceElem.textContent = isSub ? item.dataset.subscriptionPrice : item.dataset.price;
    });
    const selected = document.querySelector(".product-offer__variant-item.selected");
    if (selected) updateButton(selected);
  }

  if (subscriptionCheckbox) {
    subscriptionCheckbox.addEventListener("change", function () {
      isSub = subscriptionCheckbox.checked;
      updateAllItemsPrice();
    });
  }

  items.forEach((item, index) => {
    item.addEventListener("click", () => {
      items.forEach((i) => i.classList.remove("selected"));
      item.classList.add("selected");
      updateButton(item);
    });

    if (index === 1) {
      item.classList.add("selected");
      updateButton(item);
    }
  });

  document.getElementById("buy-now").addEventListener("click", function (e) {
    e.preventDefault();

    const btn = this;
    btn.classList.add("loading");

    const selected = document.querySelector(".product-offer__variant-item.selected");
    if (!selected) {
      btn.classList.remove("loading");
      return;
    }

    const variantId = selected.dataset.id;
    const quantity = parseInt(selected.dataset.quantity);

    const payload = { id: variantId, quantity: quantity };

    if (subscriptionCheckbox?.checked && subscriptionCheckbox.dataset.sellingPlanId) {
      payload.selling_plan = subscriptionCheckbox.dataset.sellingPlanId;
    }

    const freeItems = selected.querySelectorAll("[data-free-id]");
    const freeProductsPayload = Array.from(freeItems).map(li => ({
      id: li.dataset.freeId,
      quantity: 1
    }));

    const itemsToAdd = [
      {
        id: variantId,
        quantity: quantity,
        ...(subscriptionCheckbox?.checked && subscriptionCheckbox.dataset.sellingPlanId
          ? { selling_plan: subscriptionCheckbox.dataset.sellingPlanId }
          : {})
      },
      ...freeProductsPayload
    ];

    fetch("/cart/clear.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" }
    })
    .then(() => fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: itemsToAdd })
    }))
    .then(() => {
      document.dispatchEvent(new CustomEvent("cart:refresh"));

      if (window.UpCart?.openCart) {
        window.UpCart.openCart();
      } else {
        document.dispatchEvent(new CustomEvent("upcart:open"));
      }
    })
    .catch(err => console.error(err))
    .finally(() => {
      btn.classList.remove("loading");
    });
  });

  //const buyNowButton = document.querySelector("#buy-now, .product-offer__btn, .product-offer__btn-kaching");

  /*if (buyNowButton) {
  buyNowButton.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    window.__directCheckoutInProgress = true;
    document.body.classList.add("direct-checkout-in-progress");

    setTimeout(() => {
      window.__directCheckoutInProgress = false;
      document.body.classList.remove("direct-checkout-in-progress");
    }, 5000);

    const originalUpCartOpen = window.UpCart?.openCart;

    if (window.UpCart && typeof window.UpCart.openCart === "function") {
      window.UpCart.openCart = function () {
        if (window.__directCheckoutInProgress) return;
        return originalUpCartOpen.apply(window.UpCart, arguments);
      };
    }

    const blockUpcartOpenEvent = function (event) {
      if (window.__directCheckoutInProgress) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    };

    document.addEventListener("upcart:open", blockUpcartOpenEvent, true);
    document.addEventListener("cart:open", blockUpcartOpenEvent, true);

    const btn = this;
    btn.classList.add("loading");

    const selected = document.querySelector(".product-offer__variant-item.selected");

    if (!selected) {
      btn.classList.remove("loading");

      window.__directCheckoutInProgress = false;
      document.body.classList.remove("direct-checkout-in-progress");

      document.removeEventListener("upcart:open", blockUpcartOpenEvent, true);
      document.removeEventListener("cart:open", blockUpcartOpenEvent, true);

      if (window.UpCart && originalUpCartOpen) {
        window.UpCart.openCart = originalUpCartOpen;
      }

      return;
    }

    const variantId = selected.dataset.id;
    const quantity = parseInt(selected.dataset.quantity);

    const freeItems = selected.querySelectorAll("[data-free-id]");
    const freeProductsPayload = Array.from(freeItems).map(li => ({
      id: li.dataset.freeId,
      quantity: 1
    }));

    const itemsToAdd = [
      {
        id: variantId,
        quantity: quantity,
        ...(subscriptionCheckbox?.checked && subscriptionCheckbox.dataset.sellingPlanId
          ? { selling_plan: subscriptionCheckbox.dataset.sellingPlanId }
          : {})
      },
      ...freeProductsPayload
    ];

    fetch("/cart/clear.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" }
    })
    .then(() => fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: itemsToAdd })
    }))
    .then(() => {
      window.location.assign("/checkout");
      return;
    })
    .catch(err => {
      console.error(err);

      window.__directCheckoutInProgress = false;
      document.body.classList.remove("direct-checkout-in-progress");

      document.removeEventListener("upcart:open", blockUpcartOpenEvent, true);
      document.removeEventListener("cart:open", blockUpcartOpenEvent, true);

      if (window.UpCart && originalUpCartOpen) {
        window.UpCart.openCart = originalUpCartOpen;
      }

      window.location.href = "/cart";
    })
    .finally(() => {
      btn.classList.remove("loading");
    });
  }, true);
  }*/

});



window.addEventListener('pageshow', () => {
  const btn = document.getElementById('buy-now');
  if (!btn) return;

  btn.classList.remove('loading');
  btn.disabled = false;
});

/*window.addEventListener('pageshow', () => {
  window.__directCheckoutInProgress = false;
  document.body.classList.remove("direct-checkout-in-progress");

  const btn = document.getElementById('buy-now');
  if (!btn) return;

  btn.classList.remove('loading');
  btn.disabled = false;
});*/

// faq
document.addEventListener('DOMContentLoaded', function() {
  const items = document.querySelectorAll('.product-offer__acc-item');

  items.forEach(item => {
    const trigger = item.querySelector('.product-offer__acc-item-title');
    const content = item.querySelector('.product-offer__acc-item-description');

    content.style.height = '0px';
    content.style.overflow = 'hidden';
    content.style.paddingBottom = '0px';

    trigger.addEventListener('click', () => {
      const isOpen = item.classList.contains('is-open');

      items.forEach(otherItem => {
        const otherContent = otherItem.querySelector('.product-offer__acc-item-description');
        if (otherItem !== item) {
          otherItem.classList.remove('is-open');
          otherContent.style.height = '0px';
          otherContent.style.paddingBottom = '0px';
        }
      });

      if (isOpen) {
        content.style.height = '0px';
        content.style.paddingBottom = '0px';
        item.classList.remove('is-open');
      } else {
        item.classList.add('is-open');

        content.style.height = 'auto';
        const fullHeight = content.scrollHeight + 'px';
        content.style.height = '0px';

        requestAnimationFrame(() => {
          content.style.height = fullHeight;
          content.style.paddingBottom = '20px';
        });
      }
    });
  });
});

// sticky button
document.addEventListener('DOMContentLoaded', function () {
  const sticky = document.querySelector('.product-offer__sticky');
  const wrapper = document.querySelector('.product-offer__container');
  const footer = document.querySelector('.site-footer');

  if (!sticky) return;

  let passedWrapper = false;

  if (wrapper) {
    const wrapperObserver = new IntersectionObserver(
      ([entry]) => {
        passedWrapper = !entry.isIntersecting;

        if (passedWrapper) {
          sticky.classList.add('fixed');
        } else {
          sticky.classList.remove('fixed');
        }
      },
      { threshold: 0 }
    );

    wrapperObserver.observe(wrapper);
  }

  if (footer) {
    const footerObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          sticky.classList.remove('fixed');
        } else {
          if (passedWrapper) {
            sticky.classList.add('fixed');
          }
        }
      },
      { threshold: 0 }
    );

    footerObserver.observe(footer);
  }
});

// kaching button price updates
document.addEventListener("DOMContentLoaded", function () {
  const btn = document.querySelector(".product-offer__btn-kaching");
  if (!btn) return;

  const btnCompare = btn.querySelector(".btn-compare");

  function updateComparePrice() {
    const selectedBar = document.querySelector(".kaching-bundles__bar--selected");
    if (!selectedBar) return;

    const compareEl = selectedBar.querySelector(".kaching-bundles__bar-full-price");
    if (!compareEl) return;

    btnCompare.textContent = compareEl.textContent.trim();
  }

  updateComparePrice();

  document.addEventListener("click", function (e) {
    if (e.target.closest(".kaching-bundles__bar")) {
      setTimeout(updateComparePrice, 50);
    }
  });

  const observer = new MutationObserver(() => {
    updateComparePrice();
  });

  document.querySelectorAll(".kaching-bundles__bar").forEach(bar => {
    observer.observe(bar, {
      attributes: true,
      attributeFilter: ["class"]
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const productOffer = document.querySelector(".product-offer");
  if (!productOffer) return;

  const tier2Image = productOffer.getAttribute("data-bundle-image-2");
  const tier3Image = productOffer.getAttribute("data-bundle-image-3");

  const bundleImageAbEnabled = productOffer.getAttribute("data-bundle-image-ab-enabled") === "true";

  /*
   * Save the actual original first product image.
   * This becomes Tier 1 and avoids depending on product.featured_image.
   */
  let tier1Image = "";

  function getOriginalTier1Image() {
    if (tier1Image) return tier1Image;

    const originalImage = productOffer.querySelector(
      '.product-offer__main-slider .swiper-slide[data-swiper-slide-index="0"] img'
    ) || productOffer.querySelector(
      ".product-offer__main-slider .swiper-slide img"
    );

    if (!originalImage) return "";

    tier1Image =
      originalImage.currentSrc ||
      originalImage.getAttribute("src") ||
      originalImage.getAttribute("data-src") ||
      "";

    return tier1Image;
  }

  function getTierImage(tier, variant) {
    const defaultImage = tier === 2 ? tier2Image : tier3Image;

    if (!bundleImageAbEnabled) {
      return defaultImage || getOriginalTier1Image();
    }

    const variantImage = ["a", "b", "c"].includes(variant)
      ? productOffer.getAttribute(
          `data-bundle-image-${tier}-${variant}`
        )
      : "";

    return variantImage || defaultImage || getOriginalTier1Image();
  }

  function updateImage(img, newImageUrl) {
    if (!img || !newImageUrl) return;

    img.setAttribute("src", newImageUrl);
    img.src = newImageUrl;

    img.removeAttribute("srcset");
    img.removeAttribute("data-src");
    img.removeAttribute("data-srcset");

    if (img.parentElement?.tagName === "PICTURE") {
      img.parentElement
        .querySelectorAll("source")
        .forEach(function (source) {
          source.removeAttribute("srcset");
          source.removeAttribute("data-srcset");
        });
    }
  }

  function getBundleBars() {
    return Array.from(
      document.querySelectorAll(".kaching-bundles__bar")
    );
  }

  function getSelectedBundleIndex() {
    /* Preserve the original behavior for other products */
    if (!bundleImageAbEnabled) {
      const bars = getBundleBars();
      const selectedBar = document.querySelector(
        ".kaching-bundles__bar--selected"
      );

      if (!bars.length || !selectedBar) return -1;
      return bars.indexOf(selectedBar);
    }

    /* Test product: count tiers within its own Kaching block */
    const selectedBar = productOffer.querySelector(
      ".kaching-bundles__bar--selected"
    );

    const block = selectedBar?.closest(".kaching-bundles__block");
    if (!block) return -1;

    const bars = Array.from(
      block.querySelectorAll(".kaching-bundles__bar")
    ).filter(bar => bar.closest(".kaching-bundles__block") === block);

    return bars.indexOf(selectedBar);
  }

function getAssignedTestVariant() {
  if (!bundleImageAbEnabled) return "";

  const selectedBar = productOffer.querySelector(
    ".kaching-bundles__bar--selected"
  );

  return (
    selectedBar
      ?.closest(".kaching-bundles__block")
      ?.getAttribute("data-ab-test-variant") || ""
  ).trim().toLowerCase();
}

  function updateMainImageFromKaching() {
    const selectedIndex = getSelectedBundleIndex();

    if (selectedIndex < 0) return;

    /*const bundleImages = [
      getOriginalTier1Image(),
      tier2Image,
      tier3Image
    ];*/

    const variant = getAssignedTestVariant();

    const bundleImages = [
      getOriginalTier1Image(),
      getTierImage(2, variant),
      getTierImage(3, variant)
    ];

    /*
     * If a Tier 2 or Tier 3 metafield is missing,
     * keep the original product image.
     */
    const newImageUrl =
      bundleImages[selectedIndex] || bundleImages[0];

    if (!newImageUrl) return;

    const mainImages = productOffer.querySelectorAll(
      '.product-offer__main-slider .swiper-slide[data-swiper-slide-index="0"] img, ' +
      '.product-offer__main-slider .swiper-slide-duplicate[data-swiper-slide-index="0"] img'
    );

    mainImages.forEach(function (img) {
      updateImage(img, newImageUrl);
    });

    /*
     * Fallback in case the theme does not output
     * data-swiper-slide-index on desktop.
     */
    if (!mainImages.length) {
      const firstMainImage = productOffer.querySelector(
        ".product-offer__main-slider .swiper-slide:first-child img"
      );

      updateImage(firstMainImage, newImageUrl);
    }

    const thumbnailImages = productOffer.querySelectorAll(
      '.product-offer__nav-slider .swiper-slide[data-swiper-slide-index="0"] img'
    );

    thumbnailImages.forEach(function (img) {
      updateImage(img, newImageUrl);
    });

    if (!thumbnailImages.length) {
      const firstThumbnailImage = productOffer.querySelector(
        ".product-offer__nav-slider .swiper-slide:first-child img"
      );

      updateImage(firstThumbnailImage, newImageUrl);
    }

    const mainSliderEl = productOffer.querySelector(
      ".product-offer__main-slider"
    );

    if (mainSliderEl?.swiper) {
      if (typeof mainSliderEl.swiper.slideToLoop === "function") {
        mainSliderEl.swiper.slideToLoop(0, 0);
      } else {
        mainSliderEl.swiper.slideTo(0, 0);
      }

      mainSliderEl.swiper.update();
    }

    const navSliderEl = productOffer.querySelector(
      ".product-offer__nav-slider"
    );

    if (navSliderEl?.swiper) {
      navSliderEl.swiper.slideTo(0, 0);
      navSliderEl.swiper.update();
    }
  }

  /*
   * Kaching can change the selected tier after the click.
   */
  document.addEventListener("click", function (event) {
    if (!event.target.closest(".kaching-bundles__bar")) return;

    setTimeout(updateMainImageFromKaching, 50);
    setTimeout(updateMainImageFromKaching, 200);
    setTimeout(updateMainImageFromKaching, 500);
  });

  /*
   * Watch the full document because Kaching may inject
   * or rebuild its bundle elements after page load.
   */
  const kachingObserver = new MutationObserver(function (mutations) {
    const relevantChange = mutations.some(function (mutation) {
      const target = mutation.target;

      return (
        target instanceof Element &&
        (
          target.classList.contains("kaching-bundles__bar") ||
          target.closest(".kaching-bundles__bar") ||
          target.querySelector?.(".kaching-bundles__bar")
        )
      );
    });

    if (relevantChange) {
      setTimeout(updateMainImageFromKaching, 50);
    }
  });

  kachingObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: bundleImageAbEnabled ? ["class", "data-ab-test-variant"] : ["class"]
  });

  /*
   * Initial attempts while Swiper and Kaching initialize.
   */
  setTimeout(function () {
    getOriginalTier1Image();
    updateMainImageFromKaching();
  }, 500);

  setTimeout(updateMainImageFromKaching, 1000);
  setTimeout(updateMainImageFromKaching, 2000);
});